module.exports = __webpack_public_path__ + "img/noFiles.354b8d19.png";